"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processResourceData = void 0;
var javascript_sdk_1 = require("@mdap/javascript-sdk");
var log_1 = require("@mdap/javascript-sdk/lib/utils/log");
var observer_1 = require("./observer");
var isResource = function isResource(entry) {
  return entry.entryType === 'resource';
};
var supportObserveType = function supportObserveType(type) {
  var _a, _b;
  return (_b = (_a = window.PerformanceObserver) === null || _a === void 0 ? void 0 : _a.supportedEntryTypes) === null || _b === void 0 ? void 0 : _b.includes(type);
};
var supportGetEntriesByType = typeof ((_a = window.performance) === null || _a === void 0 ? void 0 : _a.getEntriesByType) === 'function';
// 支持的标签类型
var SupportInitiatorType = ['script', 'link', 'img'];
var initiatorTypeMap = {
  script: 'script',
  link: 'css',
  img: 'image'
};
var resourceTypeMap = {
  script: 'js',
  css: 'css',
  image: /jpg|jpeg|png|svg|gif|ico/,
  json: 'json'
};
var getFileType = function getFileType(url) {
  var _a;
  return (_a = url.match(/\.(\w{2,5})$/)) === null || _a === void 0 ? void 0 : _a[1];
};
var UNKNOWN = 'unknown';
var getResourceType = function getResourceType(src, initiatorType) {
  if (SupportInitiatorType.includes(initiatorType)) {
    var resourceType = initiatorTypeMap[initiatorType];
    if (resourceType) {
      return resourceType;
    }
  }
  var fileType = getFileType(src);
  for (var _i = 0, _a = Object.keys(resourceTypeMap); _i < _a.length; _i++) {
    var type = _a[_i];
    var rule = resourceTypeMap[type];
    if (fileType === null || fileType === void 0 ? void 0 : fileType.match(rule)) {
      return type;
    }
  }
  return undefined;
};
var resourceTimingKeys = ['connect_end', 'connect_start', 'decoded_body_size', 'domain_lookup_end', 'domain_lookup_start', 'encoded_body_size', 'fetch_start', 'initiator_type', 'next_hop_protocol', 'redirect_end', 'redirect_start', 'request_start', 'response_end', 'response_start', 'secure_connection_start', 'time_origin', 'transfer_size', 'worker_start'];
var isStringProperty = function isStringProperty(key) {
  return ['initiator_type', 'next_hop_protocol'].includes(key);
};
/** 预处理resource数据 */
var processResourceData = function processResourceData(entry) {
  var _a, _b;
  var result = {};
  for (var _i = 0, resourceTimingKeys_1 = resourceTimingKeys; _i < resourceTimingKeys_1.length; _i++) {
    var key = resourceTimingKeys_1[_i];
    // convert into camelCase
    var entryKey = key.replace(/_([a-z])/g, function () {
      var match = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        match[_i] = arguments[_i];
      }
      return match[1].toLocaleUpperCase();
    });
    if (isStringProperty(key)) {
      result[key] = entry[entryKey] || UNKNOWN;
    } else {
      result[key] = entry[entryKey] >= 0 ? Math.round(entry[entryKey]) : -1;
    }
  }
  result.time_origin = Math.round((_b = (_a = performance.timeOrigin) !== null && _a !== void 0 ? _a : performance.timing.navigationStart) !== null && _b !== void 0 ? _b : -1);
  return result;
};
exports.processResourceData = processResourceData;
// KiB per second - 保留两位小数
var getLoadSpeed = function getLoadSpeed(entry) {
  var supportSpeed = 'transferSize' in entry && 'duration' in entry && entry.transferSize > 0 && entry.duration > 0;
  if (!supportSpeed) {
    return -1;
  }
  return Math.round(entry.transferSize / entry.duration / 10.24) / 100;
};
var isLinkElement = function isLinkElement(target) {
  return target.localName === 'link';
};
var isSrcElement = function isSrcElement(target) {
  return SupportInitiatorType.includes(target.localName);
};
var DEFAULT_LOGIC_STATUS_CODE = 0;
var HTTP_STATUS_CODE = {
  SUCCESS: 200,
  FAILED: 400,
  /** 用于补充的数据 */
  PATCH: 10000
};
var ResourcePlugin = /** @class */function (_super) {
  __extends(ResourcePlugin, _super);
  function ResourcePlugin(configs) {
    var _this = _super.call(this, configs) || this;
    _this.type = 'resource';
    /** 为false时，无法监测收集到动态加载的资源信息，需要进行数据补充 */
    _this.supportObserver = true;
    _this.configs = configs;
    return _this;
  }
  ResourcePlugin.prototype.register = function (props) {
    //
    this.triggerHandler = props.trigger;
    this.projectId = props.app_name;
    ResourcePlugin.TRIGGER_MAPS[props.app_name] = {
      match: this.isMatch.bind(this),
      triggerFunciton: props.trigger
    };
    this.init();
  };
  ResourcePlugin.prototype.init = function () {
    try {
      this.observeError();
      this.handleLoadedResource();
      // 初始化兼容性信息
      if (typeof this.addLabels === 'function') {
        this.addLabels({
          supportObserveType: supportObserveType('resource') ? 'true' : 'false',
          supportGetEntriesByType: supportGetEntriesByType ? 'true' : 'false'
        });
      }
      if (ResourcePlugin.filled) {
        return;
      }
      this.observe();
    } catch (error) {
      log_1.Logger.log('Failed to init mdap resource plugin');
      log_1.Logger.error(error);
    }
  };
  ResourcePlugin.prototype.isMatch = function (url) {
    var _a;
    if (!((_a = this.configs.path) === null || _a === void 0 ? void 0 : _a.length)) {
      return true;
    }
    var match = false;
    for (var _i = 0, _b = this.configs.path; _i < _b.length; _i++) {
      var rule = _b[_i];
      if (url.match(rule)) {
        match = true;
        break;
      }
    }
    return match;
  };
  ResourcePlugin.prototype.processData = function (entry, resourceType) {
    var _a;
    var timeOrigin = performance.timeOrigin || performance.timing.navigationStart;
    var resourceTimingData = exports.processResourceData(entry);
    var pageUrl = "" + window.location.origin + window.location.pathname;
    var startTime = Math.round(timeOrigin + entry.startTime);
    return __assign({
      url: entry.name,
      start_timestamp: startTime,
      end_timestamp: entry.responseEnd > 0 ? Math.round(timeOrigin + entry.responseEnd) : startTime,
      // mobile safari 下观测到duration可能获取不准确
      duration: Math.max(-1, (_a = Math.round(entry.duration)) !== null && _a !== void 0 ? _a : Math.round(entry.responseEnd - entry.startTime)),
      page_url: pageUrl,
      http_method: 'GET',
      logic_status_code: DEFAULT_LOGIC_STATUS_CODE,
      // TODO - 资源加载失败场景处理
      http_status_code: HTTP_STATUS_CODE.SUCCESS,
      resource_type: resourceType,
      resource_cache_type: UNKNOWN,
      resource_load_speed: getLoadSpeed(entry),
      resource_query_cache: Math.max(Math.round(entry.domainLookupStart - entry.fetchStart), 0),
      resource_load_time: Math.max(Math.round(entry.responseEnd - entry.responseStart), 0)
    }, resourceTimingData);
  };
  ResourcePlugin.prototype.handleEntry = function (entry, from) {
    if (from === void 0) {
      from = 'observer';
    }
    if (!isResource(entry)) {
      return;
    }
    // 过滤文件类型
    var resourceType = getResourceType(entry.name, entry.initiatorType);
    if (!resourceType) {
      return;
    }
    if (from === 'init') {
      if (this.isMatch(entry.name)) {
        var data = this.processData(entry, resourceType);
        this.triggerHandler(data);
      }
      return;
    }
    // 多实例共用一个observe
    for (var _i = 0, _a = Object.values(ResourcePlugin.TRIGGER_MAPS); _i < _a.length; _i++) {
      var triggerConfig = _a[_i];
      if (triggerConfig.match(entry.name)) {
        var data = this.processData(entry, resourceType);
        triggerConfig.triggerFunciton(data);
      }
    }
  };
  ResourcePlugin.prototype.handleLoadedResource = function () {
    var _this = this;
    if (supportGetEntriesByType) {
      performance.getEntriesByType('resource').map(function (entry) {
        _this.handleEntry(entry);
      });
    }
  };
  ResourcePlugin.prototype.observe = function () {
    var _this = this;
    if (supportObserveType('resource')) {
      ResourcePlugin.po = new PerformanceObserver(function (list) {
        return list.getEntries().map(_this.handleEntry.bind(_this));
      });
      ResourcePlugin.po.observe({
        entryTypes: ['resource']
      });
      return;
    }
    if (supportGetEntriesByType) {
      var ob = new observer_1.DynamicResourceObserver(this.projectId, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
          var entry = entries_1[_i];
          _this.handleEntry(entry);
        }
      });
      ob.observe();
      return;
    }
    this.supportObserver = false;
  };
  ResourcePlugin.prototype.removeObserve = function () {
    if (this.projectId) {
      delete ResourcePlugin.TRIGGER_MAPS[this.projectId];
    }
  };
  ResourcePlugin.prototype.disconnectObserve = function () {
    var _a;
    (_a = ResourcePlugin.po) === null || _a === void 0 ? void 0 : _a.disconnect();
  };
  // 生成资源加载错误的上报数据
  ResourcePlugin.prototype.reportErrorData = function (data) {
    if (!this.isMatch(data.src)) {
      return;
    }
    var resourceType = getResourceType(data.src, data.initiatorType);
    var timeOrigin = performance.timeOrigin || performance.timing.navigationStart;
    var time = Math.round(data.timeStamp + timeOrigin);
    var pageUrl = "" + window.location.origin + window.location.pathname;
    this.triggerHandler({
      url: data.src,
      http_method: 'GET',
      start_timestamp: time,
      end_timestamp: time,
      duration: 1,
      page_url: pageUrl,
      logic_status_code: DEFAULT_LOGIC_STATUS_CODE,
      http_status_code: HTTP_STATUS_CODE.FAILED,
      resource_type: resourceType,
      resource_cache_type: UNKNOWN
    });
    if (!this.supportObserver) {
      // 补充上报资源加载信息
      this.triggerHandler({
        url: data.src,
        http_method: 'GET',
        start_timestamp: time,
        end_timestamp: time,
        duration: 1,
        page_url: pageUrl,
        logic_status_code: DEFAULT_LOGIC_STATUS_CODE,
        http_status_code: HTTP_STATUS_CODE.PATCH,
        resource_type: resourceType,
        resource_cache_type: UNKNOWN
      });
    }
  };
  ResourcePlugin.prototype.handleError = function (evt) {
    // 判断是否为资源加载类错误
    if (isLinkElement(evt.target)) {
      this.reportErrorData({
        src: evt.target.href,
        timeStamp: evt.timeStamp,
        initiatorType: evt.target.localName
      });
      return true;
    }
    if (isSrcElement(evt.target)) {
      this.reportErrorData({
        src: evt.target.src,
        timeStamp: evt.timeStamp,
        initiatorType: evt.target.localName
      });
      return true;
    }
    return false;
  };
  ResourcePlugin.prototype.observeError = function () {
    var _this = this;
    var presetReource = window.__MDAP_PREV_RESOURCE__;
    if (presetReource === null || presetReource === void 0 ? void 0 : presetReource.data) {
      for (var _i = 0, _a = presetReource.data; _i < _a.length; _i++) {
        var errorEvent = _a[_i];
        this.handleError(errorEvent);
      }
      // TODO: 多项目集成， 不能随便移除
      // if (typeof presetReource?.removePrevListener === 'function') {
      //   presetReource.removePrevListener();
      // }
    }

    window.addEventListener('error', function (evt) {
      _this.handleError(evt);
      return false;
    }, true);
  };
  ResourcePlugin.prototype.sendData = function (data) {
    if (typeof this.triggerHandler !== 'function') {
      log_1.Logger.log('[MDAP] resource plugin is inactive');
      return;
    }
    if (!data.url) {
      log_1.Logger.info('[MDAP] URL cannot be empty');
      return;
    }
    if (typeof data.duration !== 'number') {
      log_1.Logger.info('[MDAP] Duration should be number.');
      return;
    }
    var defaultValue = {
      resource_cache_type: UNKNOWN,
      http_status_code: 200,
      http_method: 'GET',
      logic_status_code: DEFAULT_LOGIC_STATUS_CODE,
      end_timestamp: +new Date(),
      start_timestamp: +new Date() - data.duration
    };
    if (!data.resource_type) {
      defaultValue.resource_type = getResourceType(data.url, UNKNOWN);
      if (!defaultValue.resource_type) {
        log_1.Logger.info("[MDAP] Unsupported resource type. " + data.url);
        return;
      }
    }
    this.triggerHandler(__assign(__assign({}, defaultValue), data));
  };
  ResourcePlugin.TRIGGER_MAPS = {};
  ResourcePlugin.filled = false;
  return ResourcePlugin;
}(javascript_sdk_1.BasePlugin);
exports.default = ResourcePlugin;